import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import classnames from "classnames";

import { useDesktopMenuItems } from "../../menu.config";
import { useIntlTranslate } from "../../../../hooks";
import { AddDevice } from "../../../../pages/devices/components/addDevice/AddDevice";
import { ManageDevices } from "../../../../pages/devices/components/manageDevices/ManageDevices";
import {
  isMultipleUserLevel,
  isSPSONAvailable,
} from "../../../../store/account";
import { SubMenuItem } from "./SubMenu";
import {
  hasMatchingPath,
  TopLevelItem,
  TopLevelListItemWithoutSubMenu,
  TopLevelListItemWithSubMenu,
} from "./TopLevelListItem";

import "./DisclosureNavigation.scss";

export const useActiveTopLinkSubMenu = (
  items: TopLevelItem[]
): SubMenuItem[] => {
  const { pathname } = useLocation();

  const pickSubMenu = (item: TopLevelItem) => item.subMenu;

  return items
    .map(pickSubMenu)
    .filter(Boolean)
    .find((item) => hasMatchingPath(item, pathname));
};

interface TopLevelNavigationProps {
  items: TopLevelItem[];
}

const TopLevelNavigation = ({ items }: TopLevelNavigationProps) => {
  const [openedSubMenuId, setOpenedSubMenuId] = useState<string>(null);
  const translate = useIntlTranslate();

  return (
    <nav
      className="top-level-navigation"
      aria-label={translate("aria_primary_navigation")}
    >
      <ul className="top-level-list">
        {items.map((item) =>
          item.subMenu ? (
            <TopLevelListItemWithSubMenu
              key={item.id}
              item={item}
              isOpen={openedSubMenuId === item.id}
              onOpen={() => setOpenedSubMenuId(item.id)}
              onClose={() => setOpenedSubMenuId(null)}
            />
          ) : (
            <TopLevelListItemWithoutSubMenu key={item.id} item={item} />
          )
        )}
      </ul>
    </nav>
  );
};

export const primaryNavigationId = "primary-navigation-id";

export const DisclosureNavigation = () => {
  const menuItems = useDesktopMenuItems();
  const isMultiple = useSelector(isMultipleUserLevel);

  const isTopLinkActive = useActiveTopLinkSubMenu(menuItems);
  const isSPSON = useSelector(isSPSONAvailable);

  return (
    <div
      className={classnames("disclosure-navigation", {
        "disclosure-navigation--top-link-active": isTopLinkActive,
      })}
      id={primaryNavigationId}
    >
      <div className="layout__container">
        <div className="top-level-navigation-wrapper">
          <TopLevelNavigation items={menuItems} />

          {isMultiple && (isSPSON ? <ManageDevices /> : <AddDevice />)}
        </div>
      </div>
    </div>
  );
};
